module.exports = __webpack_public_path__ + "img/DE02187.b8a6b5e5.png";